import { render, staticRenderFns } from "./SettlementReports.vue?vue&type=template&id=7dbb60c9&scoped=true&"
import script from "./SettlementReports.vue?vue&type=script&lang=ts&"
export * from "./SettlementReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbb60c9",
  null
  
)

export default component.exports